






import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class Oclock extends Vue {
  time = new Date();
  baseTime = new Date();
  historyRotate = 0;
  elementStyle = "";
  created() {
    setInterval(() => {
      this.time = new Date();
      let rotate: number =
        Math.ceil(
          ((this.time.valueOf() - this.baseTime.valueOf()) / 1000) * 6
        ) +
        this.baseTime.getSeconds() * 6;
      this.elementStyle = `transform: rotate(${rotate - 60}deg);`;
    }, 1000);
  }
}
